import { Link } from "@mui/material";
import { downloadFile } from "../../helpers/request";
import LockIcon from "../LockIcon";

import classes from './index.module.scss';

const CertificateFileLink = ({ fileUrl, title = 'file', fileAvailable = true, instaDownload = false }) => {
  const onClick = (e) => {
    e.preventDefault();
    downloadFile(fileUrl);
  }

  return fileAvailable ? (
    <Link
      href={instaDownload ? '#' : fileUrl}
      target={instaDownload ? '_top' : '_blank'}
      className={classes.link}
      onClick={instaDownload ? onClick : () => {}}
    >
      {title}
    </Link>
  ) : (
    <LockIcon />
  )
}

export default CertificateFileLink;